<script>
  import { InputNumber } from 'element-ui'
  export default {
    name:'ElInputNumber',
    extends:InputNumber
  }
</script>
